export let navigation = ($) => {
    $('.js-nav-item').on("click",function(e){
        if($(this).data("hasChildren")){
            e.preventDefault()
            let navId = $(this).data("id"),
            child = $('*[data-parent-id="'+navId+'"]'),
            openItem = $('.js-nav-children.active').data("parentId")
            if(openItem != navId && typeof openItem != 'undefined'){
                $(".js-nav-children").not(child).removeClass('active')
                setTimeout(function(){child.toggleClass('active')}, 500);
            }else{
                child.toggleClass('active')
            }
        }
    })
    $(".mobile-drawer").on("click",function(){
        $(this).toggleClass('fa-bars').toggleClass('fa-times')
        $('.js-nav-drawer').toggleClass('active')
    })
};